import React from "react";
import Modal from "react-modal";
import {
  LoginAlpa,
  New_ScrollX2025,
  Star_particles,
  SX_dashboard_UI_modal,
} from "../assets/icons";
import "./UI_Modal_OTP.css";

Modal.setAppElement("#root");

export default function UI_Modal_OTP({
  isOpen,
  children,
  closeModal,
  title,
  styleTop,
  styleLeft,
  styleUnit,
}) {
  let styleModel = {
    content: {
      position: "fixed",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      backgroundImage: "var(--shadeblacklinear)",
      height: title === "Forgot Password" ? "100%" : "100%",
      width: title === "Forgot Password" ? "100%" : "100%",
      maxWidth: "100%",
      maxHeight: "100%",
      borderRadius: "0",
      outline: "none",
      padding: "0",
      overflow: "auto",
    },
    overlay:{ backgroundColor: "#1111138c", backdropFilter: "blur(8px)" },

    titleStyle: {
      fontSize: "36px",
      fontWeight: "600",
      color: title === "Forgot Password" ? "white" : "white",
      textAlign: "start",
      letterSpacing: "1px",
      lineHeight: "1.5",
    },
  };

  if (styleTop) {
    styleModel.content.top = styleTop + (styleUnit || "%");
  }
  if (styleLeft) {
    styleModel.content.left = styleLeft + (styleUnit || "%");
  }

  return (
    <Modal
      isOpen={isOpen}
      // onRequestClose={closeModal}
      style={styleModel}
      className="user_input_modal drop-shadow-2xl flex justify-center items-center w-full"
    >
      <div className="w-full h-full flex justify-center items-center scaleCnt">
        <div className="lg:w-[45%] loginRight-block flex justify-center items-center bg-[#1e1f2a] LeftBlok ">
          <div className=" w-[57%] h-1/2 flex flex-col justify-center items-center relative">
            <img className="w-[350px] absolute left-[-40%] top-[-5%]" src={Star_particles} alt=""/>
            <div className="flex items-center justify-start  w-full">
              <h1 className="text-white text-[40px] tracking-[0.015em] manrope-400">{title}</h1>
            </div>
            <div className="w-full flex justify-center pt-[2.50rem] items-center btmContent">{children}</div>
          </div>
        </div>

        <div className="lg:w-[55%] bg-[#0a0a0a] h-full flex flex-col justify-center items-center ">
          <div className="w-[55%] h-[63%] text-white">
            <div>
              <div className="flex pt-2 pb-3 items-center">
                <img className="w-[35px]" src={New_ScrollX2025} alt="icon" />
                <span className="ml-[10px] Syne text-xl font-light tracking-wide manrope-600">ScrollX.io</span>
              </div>
              <h1 className="pt-2 pb-4  text-[33px] manrope-400"><span className="manrope-800">ScrollX.io</span>, the simplest way <br /> to create your end credits</h1>
              <p className="text-base manrope-400 pr-[15%]">
                Generate stunning, production-ready end credits that are beautifully styled and perfectly structured—ready to use <br /> within minutes.
              </p>
            </div>
            <div className="mt-[14px]"><img className="scale-x-[-1] object-cover " src={LoginAlpa} alt=""/></div>
          </div>
        </div>

        {/* <span className="absolute top-0 right-0 text-lg sm:text-xl bg-[#413caa] text-center text-white rounded px-[8px] py-[2px] m-3  cursor-pointer" 
          onClick={closeModal} style={{backgroundColor:'--bg-btn-darkBlue'}}>&#10005;
        </span> */}
      </div>
    </Modal>
  );
}
